import { render, staticRenderFns } from "./FileVerify.vue?vue&type=template&id=c8bb33ca&scoped=true&"
import script from "./FileVerify.vue?vue&type=script&lang=js&"
export * from "./FileVerify.vue?vue&type=script&lang=js&"
import style0 from "./FileVerify.vue?vue&type=style&index=0&id=c8bb33ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8bb33ca",
  null
  
)

export default component.exports